export class EliotUser {

  constructor(public id? : string,
    public username? : string,
    public password? : string,
    public givenName? : string,
    public displayName? : string,
    public surname? : string,
    public email? : string,
    public country? : string,
    public role? : number,
    public language?: string,
    public languageId?: string,
    public marketingCampaigns? : boolean,
    public profiling? : boolean){}
}

export class UpsUser {

  constructor(public id : number,
    public oid : string,
    public email : string,
    public appRole : number,
    public backofficeRole : number,
    public reminderDuration : number,
    public warrantyReminderDuration : number,
    public username : string,
    public surname: string,
    public firstName: string,
    public newUser? : boolean) { }
    public promotionalVideoShowed? : boolean
    public languageId?: string 
}

export class AllowedUser {

  constructor(public id : string,
    public email : string){}
}

export class PlantOwner {

  constructor(public ownerId : string,
    public ownerEmail : string){}
}

export class InvitedUser {

  constructor(public email : string){}
}

export class UserConsent {
  constructor(public marketingCampaigns? : boolean,
    public profiling? : boolean){}
}

export class UserConsentStatus {
  constructor(public document?: ConsentDocumentType,
    public url?: string,
    public date?: Date,
    public version?: string,
    public action?: ConsentDocumentAction) { }
}

export class BaseUser {
  constructor(public userId?: number,
  public username? : string) { }
}

export enum ConsentDocumentType {
  TERMS_OF_USE = 'TermsOfUse',
  PRIVACY_POLICY = 'PrivacyPolicy'
}

export enum ConsentDocumentTypeParam {
  TERMS_OF_USE = 'ToU',
  PRIVACY_POLICY = 'Privacy_Policy'
}

export class ConsentDocumentAction {
  constructor(public type?: ConsentStatusType,
    public version?: string,
    public url?: string) { }
}

export enum ConsentStatusType {
    UPDATE = 'update',
    CONSENT = 'consent',
    NONE = 'none"'
}
